import { PUBLISH_REFUSAL_FIELDS, PUBLISH_REFUSAL_OTHER } from "../constants/stepConfig"

/**
 * What a refused publish asks the guide to fix: [{ stepId, messageKey }], one per missing thing
 * (latitude + longitude are one "meeting point"), in the wizard's step order, unknown fields last.
 * `refusal` is the api() rejection; the server lists the missing fields as data.message
 * ({ field: [messages] }). Empty when the reply names no fields (e.g. a server or network error).
 */
export const getPublishProblems = (refusal, stepIds) => {
  const fields = refusal?.data?.message
  if (!fields || typeof fields !== "object") return []
  const problems = []
  Object.keys(fields).forEach((field) => {
    const problem = PUBLISH_REFUSAL_FIELDS[field] ?? PUBLISH_REFUSAL_OTHER
    if (!problems.some((listed) => listed.messageKey === problem.messageKey)) problems.push(problem)
  })
  const position = (problem) => (stepIds.includes(problem.stepId) ? stepIds.indexOf(problem.stepId) : stepIds.length)
  return problems.sort((first, second) => position(first) - position(second))
}
